define('OutSystems/ClientRuntime/modules/Database/IndexedDB/Upgrader/IndexedDBMetadataV2Upgrader',["require", "exports", "tslib", "../../../../Exceptions", "../../../../Logger", "../../Common/EntityModelUtils", "../../DatabaseTypeUtils", "../../Metadata/EntityUpgradeStatus", "../../Metadata/MetadataTableInfo"], function (require, exports, tslib_1, Exceptions_1, Logger, EntityModelUtils, DatabaseTypeUtils_1, EntityUpgradeStatus_1, MetadataTableInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var IndexedDBMetadataV2Upgrader = (function () {
        function IndexedDBMetadataV2Upgrader(entityInfos, serializer) {
            this.entityInfos = entityInfos;
            this.serializer = serializer;
            this.VERSION = 2;
        }
        IndexedDBMetadataV2Upgrader.prototype.isNeeded = function (transaction) {
            var _a, _b;
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var existsMetadataTable, moduleKey, storedMetadata, _loop_1, this_1, _i, _c, entity, state_1;
                return tslib_1.__generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!this.hasEntityInfos()) return [3, 3];
                            return [4, transaction.existsTable(MetadataTableInfo_1.default)];
                        case 1:
                            existsMetadataTable = _d.sent();
                            if (!existsMetadataTable) {
                                return [2, false];
                            }
                            moduleKey = EntityModelUtils.getFirstItem(this.entityInfos).moduleKey;
                            return [4, EntityModelUtils.loadStoredMetadata(transaction, moduleKey)];
                        case 2:
                            storedMetadata = _d.sent();
                            _loop_1 = function (entity) {
                                var entityStored = EntityModelUtils.getFirstItem(storedMetadata.filter(function (m) { return m.KEY === entity.key; }));
                                if (entityStored && ((_b = JSON.parse((_a = entityStored.EXTRAINFO) !== null && _a !== void 0 ? _a : "{}").v) !== null && _b !== void 0 ? _b : 0) < this_1.VERSION) {
                                    return { value: true };
                                }
                            };
                            this_1 = this;
                            for (_i = 0, _c = this.entityInfos; _i < _c.length; _i++) {
                                entity = _c[_i];
                                state_1 = _loop_1(entity);
                                if (typeof state_1 === "object")
                                    return [2, state_1.value];
                            }
                            _d.label = 3;
                        case 3: return [2, false];
                    }
                });
            });
        };
        IndexedDBMetadataV2Upgrader.prototype.run = function (transaction) {
            var _a;
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var moduleKey, storedMetadata, _loop_2, this_2, _i, _b, entityInfo;
                return tslib_1.__generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!this.hasEntityInfos()) {
                                return [2];
                            }
                            moduleKey = EntityModelUtils.getFirstItem(this.entityInfos).moduleKey;
                            return [4, EntityModelUtils.loadStoredMetadata(transaction, moduleKey)];
                        case 1:
                            storedMetadata = _c.sent();
                            _loop_2 = function (entityInfo) {
                                var tableMetadata, extraInfo, shouldRecreate, shouldUpgrade;
                                return tslib_1.__generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            this_2.trace("Running initializer for entities of module '" + moduleKey + "'.");
                                            tableMetadata = EntityModelUtils.getFirstItem(storedMetadata.filter(function (m) { return m.KEY === entityInfo.key; }));
                                            extraInfo = {};
                                            shouldRecreate = true;
                                            shouldUpgrade = true;
                                            if (tableMetadata) {
                                                extraInfo = JSON.parse((_a = tableMetadata.EXTRAINFO) !== null && _a !== void 0 ? _a : "{}");
                                                shouldRecreate = tableMetadata.UPGRADESTATUS === EntityUpgradeStatus_1.default.Unchanged;
                                                shouldUpgrade = tableMetadata.UPGRADESTATUS === EntityUpgradeStatus_1.default.Recreated;
                                            }
                                            if (!shouldRecreate) return [3, 2];
                                            this_2.trace("Table " + entityInfo.tableName + " (" + entityInfo.name + ") exists and will be fully upgraded");
                                            return [4, EntityModelUtils.recreateTable(transaction, entityInfo, extraInfo, this_2.serializer)];
                                        case 1:
                                            _d.sent();
                                            return [3, 3];
                                        case 2:
                                            this_2.trace("Table " + entityInfo.tableName + " (" + entityInfo.name + ") exists and will be skipped");
                                            _d.label = 3;
                                        case 3:
                                            if (!((shouldUpgrade || shouldRecreate) && entityInfo.attributes.some(function (attr) { return attr.isEntityReference; }))) return [3, 5];
                                            this_2.trace("Table " + entityInfo.tableName + " (" + entityInfo.name + ") exists and have its defaults upgraded");
                                            return [4, this_2.upgradeDefaults(transaction, entityInfo, extraInfo, this_2.serializer)];
                                        case 4:
                                            _d.sent();
                                            return [3, 6];
                                        case 5:
                                            this_2.trace("Table " + entityInfo.tableName + " (" + entityInfo.name + ") wasn't upgraded");
                                            _d.label = 6;
                                        case 6: return [2];
                                    }
                                });
                            };
                            this_2 = this;
                            _i = 0, _b = this.entityInfos;
                            _c.label = 2;
                        case 2:
                            if (!(_i < _b.length)) return [3, 5];
                            entityInfo = _b[_i];
                            return [5, _loop_2(entityInfo)];
                        case 3:
                            _c.sent();
                            _c.label = 4;
                        case 4:
                            _i++;
                            return [3, 2];
                        case 5: return [2];
                    }
                });
            });
        };
        IndexedDBMetadataV2Upgrader.prototype.cleanup = function (transaction) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var moduleKey;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.hasEntityInfos()) {
                                return [2];
                            }
                            moduleKey = EntityModelUtils.getFirstItem(this.entityInfos).moduleKey;
                            this.trace("Running initializer cleanup for entities of module '" + moduleKey + "'.");
                            return [4, EntityModelUtils.dropBackupTables(transaction, moduleKey)];
                        case 1:
                            _a.sent();
                            this.trace("Initializer cleanup for entities of module '" + moduleKey + "' ran successfully.");
                            return [2];
                    }
                });
            });
        };
        IndexedDBMetadataV2Upgrader.prototype.upgradeDefaults = function (transaction, info, metadata, serializer) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var dbRecords, _i, dbRecords_1, dbRecord, error_1, errorMessage;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            return [4, transaction.getAllRecords(info)];
                        case 1:
                            dbRecords = _a.sent();
                            for (_i = 0, dbRecords_1 = dbRecords; _i < dbRecords_1.length; _i++) {
                                dbRecord = dbRecords_1[_i];
                                this.fillWithDefaultsIfNull(dbRecord, info, serializer);
                            }
                            return [4, transaction.upsertAllRecords(info, dbRecords)];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_1 = _a.sent();
                            errorMessage = "Unable to upgrade the definition of entity '" + info.name + "':\n" + Exceptions_1.getMessage(error_1);
                            this.trace(errorMessage);
                            throw new Exceptions_1.Exceptions.DataBaseException("", errorMessage);
                        case 4: return [2];
                    }
                });
            });
        };
        IndexedDBMetadataV2Upgrader.prototype.fillWithDefaultsIfNull = function (dbRecord, info, serializer) {
            for (var _i = 0, _a = info.attributes; _i < _a.length; _i++) {
                var expectedAttr = _a[_i];
                var attrName = expectedAttr.columnName;
                if (expectedAttr.isEntityReference && dbRecord[attrName] === null) {
                    var defaultValue = expectedAttr.default === undefined ? DatabaseTypeUtils_1.typeDefaultValue(expectedAttr.type) : expectedAttr.default;
                    dbRecord[attrName] = serializer.serialize(defaultValue, expectedAttr);
                }
            }
        };
        IndexedDBMetadataV2Upgrader.prototype.hasEntityInfos = function () {
            return this.entityInfos && this.entityInfos.length > 0;
        };
        IndexedDBMetadataV2Upgrader.prototype.trace = function (message) {
            Logger.trace(this, message);
        };
        return IndexedDBMetadataV2Upgrader;
    }());
    exports.default = IndexedDBMetadataV2Upgrader;
});
//# sourceMappingURL=IndexedDBMetadataV2Upgrader.js.map;
